export const Title = () => {
    return <h1>Let's Play Blackjack!</h1>
}